import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { withNamespaces } from "react-i18next";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { toggleSideBar } from "~/store/ducks/applicationMenu/actionTypes";
import { Accordion } from "../../../../../containers/Menus_v2/components/Accordion";

const MenuReports = ({
  reportsOptions,
  selectedItem,
  setSelectedItem,
  setTableInfo,
  setColumnsToAdd,
  setFiltersToAdd,
  setTitleToCard,
  setFilterState,
  setCheckboxes,
  setSelectAll,
  setListToExport,
  translations,
  isMobile,
  setIsSidebarVisible,
  t,
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.globalReducer);
  const { userSettings } = useSelector((state) => state.userSettingsReducer);
  const [expanded, setExpanded] = useState(null);
  let language = userSettings?.language ? userSettings.language : "pt";
  const lingua = language.trim();

  const handleClickItem = (item, index) => {
    if (item === selectedItem) return;

    setTableInfo([]);
    setColumnsToAdd([]);
    setFiltersToAdd([]);
    setTitleToCard("");
    setFilterState({});
    setCheckboxes([]);
    setSelectAll(false);
    setListToExport([]);
    setSelectedItem(item);
    setExpanded(index); // Set the expanded state to the corresponding index
    if (isMobile) dispatch(toggleSideBar());
  };

  const handleAccordionToggle = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const getSelected1Lvl = (item) => {
    return item === selectedItem
      ? "menu-item-wrap-lvl2 selected-lvl2"
      : "menu-item-wrap-lvl2";
  };

  const getSelected2Lvl = (item) => {
    return item === selectedItem
      ? "menu-item-wrap-lvl3 selected-lvl3"
      : "menu-item-wrap-lvl3";
  };

  return (
    <>
      <div className="title">{t("portalrh.reports.reports")}</div>
      {reportsOptions.length > 0 &&
        reportsOptions.map((report, index) => {
          const reportKey = Object.keys(report)[0];
          const reportDetails = report[reportKey];

          return (
            <Accordion
              key={uuid()}
              title={
                translations[lingua] && translations[lingua][reportKey]
                  ? translations[lingua][reportKey]
                  : reportKey
              }
              show={expanded === index}
              icon={false}
              onClick={() => handleAccordionToggle(index)}
            >
              {reportDetails.map((detail) => {
                const detailKey = Object.keys(detail)[0];
                const detailInfo = detail[detailKey];
                const hasPermission = user.roles.some(
                  (role) =>
                    role.label === detailInfo.application &&
                    role.permissions.some(
                      (permission) =>
                        permission.label === detailInfo.permissions
                    )
                );
                return (
                  hasPermission && (
                    <div
                      key={uuid()}
                      className={getSelected2Lvl(detail)}
                      onClick={() => handleClickItem(detail, index)}
                    >
                      {translations[lingua] && translations[lingua][detailKey]
                        ? translations[lingua][detailKey]
                        : detailKey}
                    </div>
                  )
                );
              })}
            </Accordion>
          );
        })}
    </>
  );
};

export default withNamespaces()(MenuReports);